export const basketPageUrl = '/basket';
export const checkoutPageUrl = '/checkout';
export const loginPageUrl = '/auth/login';
